export default "__VITE_ASSET__Dp8mokW4__"